













































































import { Component, Vue } from "vue-property-decorator"
import { mapState } from "vuex"
import QDatePicker from "@/components/Booking/QDatePicker.vue"

@Component({
  components: {
    QDatePicker
  },
  computed: {
    ...mapState("Candidate", {
      candidate: "candidate"
    })
  }
})
export default class CandidateDashboardCandidateForm extends Vue {
  isLoading = false

  // candidate State
  candidate!: Candidate

  submit() {
    this.isLoading = true
    this.$store.dispatch("Candidate/create").then(() => {
      this.$store.dispatch("Auth/fetchUser")
    })
  }
}
